// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions
// tslint:disable:no-big-function

import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';
import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';
import {
  IUserFeedbackAnimationType,
  IUserFeedbackQuestionContextType,
} from 'models-user-feedback';

import { createInstanceWithChildren } from '../../../../utils/dynamic-items-utils';
import { ScrollableRecommendationPanelBuilder } from '../../../builders/scrollable-recommendation-panel-builder';
import { feedbackQuestionContainerId } from '../../../components/panels/scrollable-panel';
import { SeeMoreSearchByFilters } from '../../../components/see-more-search-by-filters';
import { CategorySelect } from '../../../components/selects/category-filter-select';
import { SortByMostBoughtSelect } from '../../../components/selects/sort-by-most-bought-select';
import { colorByPreset } from '../../../helpers/background-color-by-header-preset-select';
import { panelTrackingIdByHeaderPresetSelect } from '../../../helpers/panel-tracking-id-by-header-preset-select';
import { BOUGHT_THIS_SEASON_PROVIDERS_PROPERTIES } from '../../../properties/bought-this-season-provider-properties';
import { DEFAULT_ROOT_PROPERTIES } from '../../../properties/default-root-properties';
import { DEFAULT_ROOT_STYLES } from '../../../properties/default-root-styles';
import { PANEL_STYLING_PROPERTIES } from '../../../properties/panel-styling-properties';
import { PANEL_TRACKING_PROPERTIES } from '../../../properties/panel-tracking-properties';
import { PRODUCT_ITEM_VIEW_PROPERTIES } from '../../../properties/product-item-view-properties';
import { SCROLLABLE_PANEL_PROPERTIES } from '../../../properties/scrollable-panel-properties';
import { SEE_MORE_LINK_PROPERTIES } from '../../../properties/see-more-link-properties';
import { SHOW_PANEL } from '../../../properties/show-panel-property';

export function createHorizontalScrollablePanelBoughtThisSeason() {
  const root = createInstanceWithChildren({
    id: 'root',
    contentTypeId: 'dynamic-collections-renderer',
    styles: {
      ...DEFAULT_ROOT_STYLES,
    },
    data: {
      ...DEFAULT_ROOT_PROPERTIES,
      ...SCROLLABLE_PANEL_PROPERTIES,
      ...PANEL_TRACKING_PROPERTIES,
      ...PANEL_STYLING_PROPERTIES,
      ...SEE_MORE_LINK_PROPERTIES,
      ...BOUGHT_THIS_SEASON_PROVIDERS_PROPERTIES,
      ...PRODUCT_ITEM_VIEW_PROPERTIES,
      headerText: recommendationsPanelsLocaleKeys.buyAgain,
      noItemsText:
        recommendationsPanelsLocaleKeys.itSeemsNoItemsHaveBeenOrderedYet,
      showProductCardIcons: true,
      showProductTitle: true,
      showUserNameInPanelTitle: true,
      ...SHOW_PANEL,
      activeByPreset: false,
      colorByPreset: null,
      headerVariables: [],
    },
    children: [],
  });

  const horizontalScrollablePanelRecommendatonPanel =
    new ScrollableRecommendationPanelBuilder().build();

  root.children.push(
    horizontalScrollablePanelRecommendatonPanel.scrollablePanel,
  );

  return mergeMultipleConfigs(root, [
    {
      id: 'root',
      data: {
        selectedCategory: {
          provider: 'id:category-filter-select',
          property: 'toggleFilter',
          startWith: [],
        },
      },
    },
    {
      id: 'root',
      data: {
        selectedSortByMostBought: {
          provider: 'id:sort-by-most-bought-select',
          property: 'toggleFilter',
          startWith: ['1'],
        },
      },
    },
    {
      id: 'root',
      styles: {
        variables: {
          '--product-card-icons-font-size': '0.6rem',
          '--product-card-icons-gender-icon-font-size': '0.75rem',
          '--product-card-icons-gender-icon-margin-right': '0.5rem',
          '--product-price-title-font-size': '0.5rem',
          '--product-price-value-font-size': '0.8rem',
          '--product-price-value-color': '#222222',
          '--product-price-title-color': '#777777',
          '--product-card-icons-flex-direction': 'column',
          '--product-card-icons-align-items': 'start',
        },
      },
    },
    {
      id: 'filters-container',
      children: [CategorySelect, SortByMostBoughtSelect],
      if: ['EQ', [{ provider: 'id:root', property: 'hasHeaderFilters' }, true]],
    },
    {
      id: 'footer-container',
      if: ['EQ', [true, true]],
      children: [SeeMoreSearchByFilters],
    },
    {
      id: feedbackQuestionContainerId,
      inputs: {
        contextType: IUserFeedbackQuestionContextType.PanelBoughtThisSeason,
        animationType: IUserFeedbackAnimationType.SlideFromLeft,
      },
    },
    colorByPreset,
    panelTrackingIdByHeaderPresetSelect,
  ])[0];
}
